import type {
  TableSettings,
  UsersMeSettingsPatchRequestBody,
  UsersMeSettingsResponseBody,
} from '@ipfabric/utils';
import type { TableCommandFactory } from 'components/Table/model/TableModel';

interface SaveTableSettingsCommand {
  settings?: TableSettings | null;
}

export const saveTableSettings: TableCommandFactory<
  SaveTableSettingsCommand | undefined
> = (cmdContext) => async (command) => {
  if (cmdContext.getState().externalSettings) {
    return;
  }
  const tableId = cmdContext.getState().id;
  if (tableId === undefined) {
    return;
  }
  const settings =
    command?.settings === undefined
      ? cmdContext.getState().settings
      : command.settings;
  await cmdContext.api.request<
    UsersMeSettingsResponseBody,
    UsersMeSettingsPatchRequestBody
  >({
    url: '/users/me/settings',
    method: 'PATCH',
    data: {
      tables: {
        [tableId]: settings,
      },
    },
  });
};
